import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import requiredIf from "react-required-if";

import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import { Price } from "../Price";

import styles from "./TariffTile.scss";

const TariffTilePrice = forwardRef((props, ref, ...restProps) => {
  const { value, prefix, suffix, placeholder } = props;

  return (
    <div ref={ref} className={styles.price}>
      <EqualHeightElement name="TariffTilePrice" placeholder={placeholder}>
        <Price
          value={value}
          prefix={prefix}
          suffix={suffix}
          variants={[Price.Variant.offering, Price.Variant.large]}
          {...restProps}
        />
      </EqualHeightElement>
    </div>
  );
});

TariffTilePrice.displayName = "TariffTile.Price";

TariffTilePrice.propTypes = {
  value: requiredIf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    (props) => !props.placeholder
  ),
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  placeholder: EqualHeightElement.propTypes.placeholder,
};

TariffTilePrice.defaultProps = {
  value: "",
  prefix: "",
  suffix: "",
  placeholder: EqualHeightElement.defaultProps.placeholder,
};

export default TariffTilePrice;
